import type { ReactNode } from 'react'
import css from './IconButton.module.css'

interface IconButtonProps {
    icon: ReactNode
    onClick: () => void
    grey?: boolean
    disabled?: boolean
    testId?: string
}

const IconButton = ({ icon, onClick, grey = false, disabled = false, testId }: IconButtonProps) => {
    const className = [
        css.button,
        grey && css.grey,
        disabled && css.disabled
    ].filter(Boolean).join(' ')

    return (
        <div className={className} onClick={disabled ? undefined : onClick} data-testid={testId}>
            {icon}
        </div>
    )
}

export default IconButton
